import apiCommons from "../config/api_commons";
import getHeaders from "./getHeaders";

export function findPicketSupplyForecast(payload) {
  const { groupId, farmId, date, signal } = payload;
  return apiCommons.get(
    `/bovexo/${groupId}/farms/${farmId}/picket/supply/forecast?date=${date}`,
    getHeaders(false, signal),
  );
}

export function savePicketSupplyForecastAdjustments(payload) {
  const { groupId, farmId, date, body } = payload;
  return apiCommons.put(
    `/bovexo/${groupId}/farms/${farmId}/picket/supply/forecast?date=${date}`,
    body,
    getHeaders(false, null),
  );
}
